import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import nl from './locales/nl.json';

i18n
  // Detects user language automatically
  .use(LanguageDetector)
  // Passes i18n down to react-i18next
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      nl: { translation: nl }
    },
    // ⬇️ THIS IS THE NEW PART TO FIX YOUR ISSUE ⬇️
    detection: {
      // 1. Where to look for the language (check local storage first)
      order: ['localStorage', 'navigator'],
      
      // 2. Where to save the user's choice so it remembers next time
      caches: ['localStorage'],
    },
    
    fallbackLng: "en", 
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;